import { Box } from '@mui/material';
import Icon from '../../../Assets/Icon/CustomIcon';
import dayjs from 'dayjs';
import { useAppNavigate } from '../../../Hooks/back/useAppNavigate';
import Global from '../../../Services/Common/Global';
import React from 'react';
import { Virtuoso } from 'react-virtuoso';
import usePhoneCall from '../../../Hooks/useCallHandler';
import { CommonActions } from '../../../Reducer/CommonReducer';
import { useDispatch } from 'react-redux';
import Commons from '../../../Services/Common/Common';

const statusStyles = {
  중지: { text: '중지', bg: '#F8AEAE', color: '#BF0000' },
  미해결: { text: '미해결', bg: '#FFE9AE', color: '#FF8A00' },
  승인: { text: '승인', bg: '#C8F0C5', color: '#1C8B00' },
  종료: { text: '종료', bg: '#DADADA', color: '#555555' },
};

export default function WorkList(props) {
  const { navigate } = useAppNavigate();
  const { handleCall } = usePhoneCall();
  const dispatch = useDispatch();

  return (
    <div style={{ height: '100%' }}>
      <Virtuoso
        style={{ height: '100%', paddingBottom: '2rem' }}
        data={props.workinfoData || []}
        itemKey={(index, item) => item.workStopCd || index}
        itemContent={(index, item) => (
          <li
            style={{
              width: '100%',
              display: 'flex',
              gap: '8px',
              alignItems: 'center',
              justifyContent: 'space-between',
              border: '1px solid #DFD9D9',
              padding: '0.8rem 1rem',
              borderRadius: '0.5rem',
              backgroundColor: 'transparent',
              cursor: 'pointer',
              fontSize: '16px',
              minHeight: '5rem',
              marginBottom: '0.5rem',
            }}
            onClick={() => {
              dispatch(CommonActions.increaseStep());

              navigate(`/M_WorkStop/detail/${item.workStopCd}`);
            }}
          >
            <div
              style={{
                display: 'flex',
                gap: '1rem',
                justifyContent: 'center',
                width: '100%',
              }}
            >
              {item.firstImage ? (
                <Box
                  sx={{
                    width: '100px',
                    height: '85px',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    flexShrink: 0,
                  }}
                >
                  <img
                    src={`${Global.file.useUrl}files/${item.firstImage}`}
                    alt="preview"
                    loading="lazy"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                </Box>
              ) : (
                <Box
                  sx={{
                    width: '100px',
                    minWidth: '100px',
                    height: '85px',
                    backgroundColor: '#f3f1f1ff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '8px',
                    flexShrink: 0,
                  }}
                >
                  <Icon.WorkInfoBaseImg width={50} height={40} />
                </Box>
              )}

              <div style={{ display: 'grid', height: '100%', width: '100%' }}>
                <div
                  style={{
                    display: 'flex',
                    gap: '0.5rem',
                    alignItems: 'center',
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: statusStyles[item.gubun]?.bg || '#EEE',
                      color: statusStyles[item.gubun]?.color || '#000',
                      display: 'flex',
                      padding: '1px 6px',
                      borderRadius: '12px',
                      alignItems: 'center',
                      fontSize: '14px',
                      fontWeight: 'bold',
                    }}
                  >
                    {statusStyles[item.gubun]?.text}
                  </Box>
                  <p style={{ fontSize: '14px' }}>{item.depNmLast}</p>
                </div>

                <p
                  style={{
                    fontWeight: 'bold',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {item.stopComment}
                </p>

                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <div>
                    <div
                      style={{
                        display: 'flex',
                        gap: '5px',
                        fontSize: '14px',
                      }}
                    >
                      <p
                        style={{
                          fontWeight: 'bold',
                          color: '#615e5eff',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          maxWidth: '80px',
                          display: 'inline-block',
                        }}
                      >
                        {item.name}
                      </p>
                      {/* <p>{item.POSITION}</p> */}
                    </div>
                    <p
                      style={{
                        color: '#968787',
                        lineHeight: '1',
                        fontSize: '14px',
                      }}
                    >
                      {dayjs(item.updateDate).format('YYYY-MM-DD')}
                    </p>
                  </div>
                  {item.createId !==
                    Commons.DecryptoAES(props.userInfo.userid) && (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <button
                        style={{
                          backgroundColor: '#8D7BF2',
                          color: '#FFFFFF',
                          fontWeight: 'bold',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.3rem',
                          padding: '4px 8px',
                          borderRadius: '4px',
                          border: 'none',
                          height: '28px',
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCall(item.tel);
                        }}
                      >
                        <Icon.PhoneFill width={20} color={'#FFFFFF'} /> 전화
                        걸기
                      </button>
                    </Box>
                  )}
                </div>
              </div>
            </div>
          </li>
        )}
        components={{
          Footer: () => <div style={{ height: '1rem' }} />,
        }}
      />
    </div>
  );
}
